<div [ngClass]="{'skeleton-loader' : isSkeleton}">
  <div [ngClass]="[finalClassname]"  *ngIf="!hideLoader" style = "min-height: 2rem">
    <span *ngIf="_loaderType == 'CIRCLE'" class="overlay-loader"></span>
  </div>
</div>

